import React from 'react';
import {Translation, withTranslation, WithTranslation} from 'react-i18next';
import {useLoaderData} from "react-router-dom";
import {getApi} from "./api/Api";
import {Article as Model} from "./model/Article";

export async function loader(obj: any) {
    const api = getApi()
    return await api.getArticle(obj.params.articleId);
}

const Article = (props: ArticleProps) => {
    const article = useLoaderData() as Model

    return !article ? (<div>Not found</div>) : (
        <Translation>
            {t =>
                <div>
                    <h2>{article.title}</h2>
                    <p>{article.introText}</p>
                    <p dangerouslySetInnerHTML={{__html: article.remainingText}}/>
                    <div className="container d-flex">
                        <span className="me-auto">{new Date(article.publishTimeMillisUtc).toLocaleString()}</span>
                    </div>
                </div>
            }
        </Translation>
    )
}

interface ArticleProps extends WithTranslation {

}

export default withTranslation()(Article)

